import HallsTableHelper from "./halls-table-helper";
import HallStandsTableHelper from "./halls-stands-table-helper";

const HallHelpers = {
    TableMain: HallsTableHelper,
    TableStands: HallStandsTableHelper,
}

export default HallHelpers;